import { AllocationRuleDto } from '@yard/app/api'

export const ALLOCATION_RULE_IDENTIFIER_PREFIX = 'new:'

export const generateAllocationRuleId = () =>
  `${ALLOCATION_RULE_IDENTIFIER_PREFIX}${crypto.randomUUID()}`

export const isNewAllocationRule = (id: string) => id.startsWith(ALLOCATION_RULE_IDENTIFIER_PREFIX)

export const copyAllocationRule = (rule: AllocationRuleDto): AllocationRuleDto => ({
  ...rule,
  facets: { ...rule.facets },
  destinations: rule.destinations.length ? rule.destinations.map(dest => ({ ...dest })) : [],
})
